import {
    CIDADE_LISTADO,
} from './cidadeActions';

const INITIAL_STATE = {
    listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case CIDADE_LISTADO: {
            const lista = action.payload.data || [];

            return {
                ...state,
                listaSelect: lista
            };
        }
        
        default:
            return state;
    }
};